// The follow-up email's default wording, used when its subject or message is
// left blank. Mirrors incentive.FollowupDefault* / FollowupDefaultLink*.
export const FOLLOWUP_DEFAULTS = {
    file: { subject: "Here's your download", body: "Thanks for confirming your subscription! Your download is ready: just use the button below." },
    link: { subject: "Here's your link", body: "Thanks for confirming your subscription! Your link is ready: just use the button below." },
};
